// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","legal":"footer-module--legal--bZ8UY"};